import * as React from 'react'

/*
 * Context.
 */

export interface PortfolioBulkEditRowContextProps {
  isActive: boolean
  setIsInteracting: React.Dispatch<React.SetStateAction<boolean>>
  setIsInView: React.Dispatch<React.SetStateAction<boolean>>
}

export const PortfolioBulkEditRowContext = React.createContext<PortfolioBulkEditRowContextProps>({
  isActive: false,
  setIsInteracting: () => {},
  setIsInView: () => {},
})

/*
 * Hook.
 */

export function usePortfolioBulkEditRowContext(): PortfolioBulkEditRowContextProps {
  return React.useContext(PortfolioBulkEditRowContext)
}

/*
 * Component.
 */

interface PortfolioBulkEditRowContextProviderProps {
  children: React.ReactNode
  hasAlwaysActiveOverride?: boolean
}
export const PortfolioBulkEditRowContextProvider = ({
  children,
  hasAlwaysActiveOverride = false,
}: PortfolioBulkEditRowContextProviderProps) => {
  const [isInteracting, setIsInteracting] = React.useState(false)
  const [isInView, setIsInView] = React.useState(false)

  return (
    <PortfolioBulkEditRowContext.Provider
      value={{ isActive: hasAlwaysActiveOverride || isInteracting || isInView, setIsInteracting, setIsInView }}
    >
      {children}
    </PortfolioBulkEditRowContext.Provider>
  )
}
